import { readHomeCache, saveHomeCache, removeHomeCache } from "@/services/homeCache"

const sources = ["parties", "events", "main"]
const fields = ["_id", "image", "link", "title", "showAfter", "hideAfter", "studios", "studio_id", "deleted", "employeeOnly", "eventDate", "location", "description", "allowSignup", "signups", "maxSignups"]
const dayFormat = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit" })

export function sliderDay(value = new Date()) {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : dayFormat.format(date)
}

export function copySliderGroups(groups) {
  const result = {}
  for (const source of sources) {
    result[source] = (groups[source] || []).filter((slide) => slide && slide.image).map((slide) => {
      const copy = {}
      for (const field of fields) {
        if (slide[field] !== undefined) copy[field] = slide[field]
      }
      return JSON.parse(JSON.stringify(copy))
    })
  }
  return result
}

export function visibleSliderGroups(groups, studioId, employee, now = new Date()) {
  const day = sliderDay(now)
  const result = copySliderGroups(groups)
  for (const source of sources) {
    result[source] = result[source].filter((slide) => {
      if (slide.deleted) return false
      const idOf = (studio) => String(studio?._id || studio)
      if (slide.studios && !slide.studios.some((studio) => idOf(studio) === studioId)) return false
      if (slide.studio_id && idOf(slide.studio_id) !== studioId) return false
      if (source === "parties" && slide.employeeOnly && !employee) return false
      // Events have no publishing window in this endpoint. Other sources use inclusive calendar days.
      if (source !== "events") {
        if (!slide.showAfter || !slide.hideAfter) return false
        const start = sliderDay(slide.showAfter)
        const end = sliderDay(slide.hideAfter)
        if (!start || !end || start > day || end < day) return false
      }
      return true
    })
  }
  return result
}

export const homeSliderStore = {
  namespaced: true,
  // Small synchronous disk copy, independent of async VuexPersistence restoration.
  state: { snapshot: null },
  mutations: {
    restore(state, { scope }) {
      if (!scope || state.snapshot?.scope === scope) return
      const cached = readHomeCache("slider", scope)
      state.snapshot = cached ? { scope, groups: copySliderGroups(cached.groups), activeId: cached.activeId } : null
    },
    reset(state) {
      state.snapshot = null
      removeHomeCache("slider")
    },
    save(state, { scope, groups, activeId }) {
      if (!scope) return
      state.snapshot = { scope, groups: copySliderGroups(groups), activeId }
      saveHomeCache("slider", scope, state.snapshot)
    },
    select(state, { scope, activeId }) {
      if (state.snapshot?.scope === scope) {
        state.snapshot.activeId = activeId
        saveHomeCache("slider", scope, state.snapshot)
      }
    },
  },
}
